
import { IngredientItem, IngredientSubItem } from "@/types/recipes";
import { defineComponent, SetupContext, computed } from "vue";
import DetailIngredientSubItem from "./DetailIngredientSubItem.vue";
import NativeClient from "@/client/native-client";
export default defineComponent({
  components: { DetailIngredientSubItem },
  name: "DetailIngredinetItem",
  props: {
    description: {
      type: String
    },
    quantity: {
      type: String
    },
    ingredient: {
      type: IngredientItem
    },
    isBottom: {
      type: Boolean,
      default: false
    },
    isTop: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const isShowSubItem = () => {
      const result =
        props.ingredient &&
        props.ingredient.items &&
        props.ingredient.items.length >= 1;
      return result;
    };

    const getIngredientSubItems = () => {
      const items = Array<IngredientSubItem>();
      if (props.ingredient && props.ingredient.items) {
        for (let i = 0; i < props.ingredient.items.length; i++) {
          items.push(new IngredientSubItem(i, props.ingredient.items[i]));
        }
      }
      return items;
    };

    const getLabelColor = () => {
      return getComputedStyle(document.documentElement).getPropertyValue(
        isShowSubItem() ? "--main-theme-color" : "--main-text-color"
      );
    };

    const styleItem = computed(() => {
      return {
        borderBottomStyle: props.isBottom ? "none" : "solid"
      };
    });

    return {
      isShowSubItem,
      getIngredientSubItems,
      getLabelColor,
      styleItem
    };
  }
});
